import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Card4.css';
import ButtonHome from '../ButtonHome';

const Card4 = () => {
  const navigate = useNavigate();
  // Estado para controlar qual dúvida está aberta
  const [openIndex, setOpenIndex] = useState(0);

  const duvidas = [
    {
      pergunta: "Dúvidas gerais",
      resposta: "A CIE (Carteira de Identificação Estudantil) é válida em todo o território nacional e garante 50% de desconto em eventos culturais e esportivos."
    },
    {
      pergunta: "Sobre o Pedido",
      resposta: "Após o pagamento e envio dos documentos, sua carteira digital é liberada em tempo recorde para uso imediato."
    },
    {
      pergunta: "Sobre a entrega",
      resposta: "A versão física é enviada para o seu endereço cadastrado via Correios, com código de rastreio disponível no painel."
    }
  ];

  return (
    <section id="duvidascomp" className="c4-section">
      <div className="c4-container">
        
        {/* Lado Esquerdo: Área da Imagem */}
        <div className="c4-image-side">
          {/* A imagem da moça sorrindo com joinha deve ser colocada via CSS ou img tag */} 
        </div>

        {/* Lado Direito: FAQ Accordion */}
        <div className="c4-content-side">
          <div className="c4-accordion">
            {duvidas.map((item, index) => (
              <div 
                key={index} 
                className={`c4-item ${openIndex === index ? 'active' : ''}`}
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              >
                <div className="c4-header">
                  <span>{item.pergunta}</span>
                  <span className="c4-arrow">{openIndex === index ? '▲' : '▼'}</span>
                </div>
                {openIndex === index && (
                  <div className="c4-body">
                    <p>{item.resposta}</p>
                  </div>
                )}
              </div>
            ))}
          </div>


          <ButtonHome onClick={() => navigate('/login')} text={'Faça agora a sua carteirinha'} />
        </div>

      </div>
    </section>
  );
};

export default Card4;